import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { TotalPrices, TotalPricesProps } from './total-prices';
import { StyledCard, StyledTitle } from './summary-information-card.styled';

interface OwnProps {
    title: string;
    content: React.ReactNode;
}

type SummaryInformationCardProps = OwnProps & TotalPricesProps;

export const SummaryInformationCard: FunctionComponent<SummaryInformationCardProps> = (props) => {
    const { title, content, totalPrices } = props;

    return (
        <StyledCard>
            <StyledTitle component="h2" variant="paragraph1" maxBreakpoint={Breakpoint.TABLET}>
                {title}
            </StyledTitle>
            {content}
            <TotalPrices totalPrices={totalPrices} />
        </StyledCard>
    );
};
